import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { DashboardRequest } from '../../../api/models/dashboardRequest';
import { DashboardResponse } from '../../../api/models/dashboardResponse';
import { Link } from '../../../api/models/link';
import { A4_PLACARD_SIZE, CONTINENTAL_REGIONS, COUNTRY_LANGUAGE, EDIT_SECTIONS, ENVIRONMENTS, RouteURLConstants } from '../../../constants/upplm.constants';
import { LANGUAGES_COUNTRIES_LOCALES } from '../../../constants/upplm.constants.dashboard';
import { DAYS_SHORTCODE_TRANSLATION } from '../../../constants/upplm.constants.pickupdetails';
import { PICKUP_LOCATION_KEY, PLACARD_LOCATION } from '../../../constants/upplm.constants.placardlocation';
import { PLACARD_STATUS } from '../../../constants/upplm.constants.qvdashboard';
import { Contact, PlacardDetails, PlacardLocation } from '../../../interface/upplm.placardInformation';
import { RawTimePipe } from '../../../pipes/formatRawTime.pipe';
import { TranslateDataPipe } from '../../../pipes/translation.pipe';
import { ContactDetailsHelperService } from '../../../services/PlacardEditionServices/upplm.contactDetailsHelper.service';
import { LocationDetailsHelperService } from '../../../services/PlacardEditionServices/upplm.locationDetailsHelper.service';
import { NotificationDetailsHelperService } from '../../../services/PlacardEditionServices/upplm.notificationDetailsHelper.service';
import { PickupDetailsHelperService } from '../../../services/PlacardEditionServices/upplm.pickupDetailsHelper.service';
import { PlacardDetailsHelperService } from '../../../services/PlacardEditionServices/upplm.placardDetailsHelper.service';
import { PlacardLocationDetailsHelperService } from '../../../services/PlacardEditionServices/upplm.placardLocationDetailsHelper.service';
import { PlacardVerificationHelperService } from '../../../services/PlacardEditionServices/upplm.placardVerificationHelper.service';
import { UpsCommonService } from '../../../services/upplm.common.service';
import { ConfigurationService } from '../../../services/upplm.configuration.service';
import { UpsDashboardService } from '../../../services/upplm.dashboard.service';
import { StoredDataService } from '../../../services/upplm.storedData.service';


@Component({
    selector: 'qv-placard-detail',
    template: require('./qvPlacardDetail.component.html'),
    providers: [LocationDetailsHelperService,
        ContactDetailsHelperService,
        NotificationDetailsHelperService,
        PickupDetailsHelperService,
        PlacardLocationDetailsHelperService,
        PlacardDetailsHelperService,
        PlacardVerificationHelperService]
})

export class QVPlacardDetailComponent implements OnInit {

    placardDetailData: DashboardResponse = new DashboardResponse();
    primaryContact: Contact = new Contact();
    requestor: Contact = new Contact();
    showRequestorContact: boolean = false;
    testContact: Contact = new Contact();
    placardStatusDetail: string = '';
    placardStatus: string = '';
    multiOffice: string = '';
    pickupScheduledDays: string[] = [];
    urlImageLink: string = '';
    paramsUrl: string = '?loc=en_US&placardid=';
    metalBoxDesc: string = '';
    showConfirmButton: boolean = false;
    request: DashboardRequest;
    shipmentType: string = '';
    placardSize: string = '';
    placardStatusToShow = '';
    //Verify if section exists
    isContactDetails: boolean = false;
    isPlacardDetails: boolean = false;
    isPickupDetails: boolean = false;
    isNotifications: boolean = false;
    isPlacardVerification: boolean = false;
    isPlacardLocation: boolean = false;
    metalBoxInd: string = '';
    notificationsDetail: string[] = [];
    temporaryPlacardLinks: Link[] = [];
    pickupLocation: string = '';
    placardLocation: string = '';
    showEditSection = false;
    showParent = true;
    sectionToEdit = '';
    @Input() placardId: string = '';
    @Output() showPlacardDetail = new EventEmitter<boolean>();
    thereArePendingChanges: boolean = false;
    countryCode: string = '';
    cfsDate: Date;
    globalRegionCountry: string = 'NA';
    globalRegioForShowTimes: string = 'NA';

    constructor(private _dashboardService: UpsDashboardService,
        private router: Router,
        private _configurationService: ConfigurationService,
        private _translate: TranslateDataPipe,
        private _commonService: UpsCommonService,
        private _locationDetailsHelperService: LocationDetailsHelperService,
        private _contactDetailsHelperService: ContactDetailsHelperService,
        private _storedDataService: StoredDataService,
        private _notificationDetailsHelperService: NotificationDetailsHelperService,
        private _pickupDetailsHelperService: PickupDetailsHelperService,
        private _placardLocationDetailsHelperService: PlacardLocationDetailsHelperService,
        private _placardDetailsHelperService: PlacardDetailsHelperService,
        private _placardVerificationHelperService: PlacardVerificationHelperService,
        private _rawTime: RawTimePipe) {
    }

    ngOnInit() {
        this.getPlacardDetail(this.placardId);
    }

    returnToListView() {
        // Send to parent a false value to hide the PlacardDetail component
        this.showPlacardDetail.emit(false);
    }

    getPlacardDetail(placardId: string) {
        this.request = new DashboardRequest();
        this.request.placardId = placardId;
        if (this._configurationService.appSettings.environment === ENVIRONMENTS.Development || this._configurationService.appSettings.environment === ENVIRONMENTS.CDE) {
            this.request.username = this._configurationService.appSettings.userName;
        }
        else {
            this.request.cookie = this._configurationService.appSettings.cookie;
        }

        this._dashboardService.getPlacardDetail(this.request).subscribe((data: DashboardResponse) => {
            this.placardDetailData = data;
            this.countryCode = this._commonService.getCountryByPlacardAddressInformation(data.placardInformation.locationDetails);
            this.globalRegioForShowTimes = this._commonService.getRegionCountry(this._commonService.locale_country);
            this.globalRegionCountry = this._commonService.getRegionCountry(this.countryCode);
            this.validateSections();
            this.setShowButtonStatus();
            this.getContacts();
            this.notificationsDetail = this.setNotifications(data.placardInformation.notifications);
            this.placardStatus = data.placardStatus;
            this.placardStatusToShow = this.setPlacardStatus(data.placardStatus, data.cancelDate);
            this.placardStatusDetail = this.setPlacardStatusDetail(data.placardStatus, data.phoneText, data.nndays, data.reactivationDate);
            this.multiOffice = this.setLocationType(data.placardInformation.placardDetails.locationType);
            this.getPickupScheduledDays();
            this.setUrlPicture();
            this.getPlacardDetails(data.placardInformation.placardDetails);
            this.temporaryPlacardLinks = this.prepareLinksForTemporaryPlacard(data.placardInformation.locationDetails.address.countryCode, data.urlTemporaryPlacard);
            this.getPlacardLocationDetails();
            this.thereArePendingChanges = this.placardDetailData && this.placardDetailData.hasPendingChanges ? true : false;
            this.getCFSDFormatted();

        });
    }

    validateSections() {
        typeof this.placardDetailData.placardInformation.placardDetails !== 'undefined' ? this.isPlacardDetails = true : this.isPlacardDetails = false
        typeof this.placardDetailData.placardInformation.pickupDetails !== 'undefined' ? this.isPickupDetails = true : this.isPickupDetails = false
        typeof this.placardDetailData.placardInformation.notifications !== 'undefined' && (this.placardDetailData.placardInformation.notifications !== null || this.placardDetailData.placardInformation.contactDetails !== null) ? this.isNotifications = true : this.isNotifications = false
        typeof this.placardDetailData.placardInformation.placardVerification !== 'undefined' && this.placardDetailData.placardInformation.placardVerification !== null ? this.isPlacardVerification = true : this.isPlacardVerification = false
        if (this.validatePlacardLocationDetails(this.placardDetailData.placardInformation.placardLocation)) {
            this.isPlacardLocation = true;
            this.metalBoxInd = this.setMetalBox(this.placardDetailData.placardInformation.placardLocation.metalBoxInd);
        }
    }

    getCFSDFormatted() {
        if (this.isPlacardVerification) {
            this.cfsDate = new Date(this.placardDetailData.placardInformation.placardVerification.customerFacingStartDate);
        }
    }

    getContacts() {
        if (this.placardDetailData.placardInformation !== undefined) {
            this.placardDetailData.placardInformation.contactDetails.forEach(function (contact) {
                if (contact.contactType === '02') {
                    this.primaryContact.email = contact.email;
                    this.primaryContact.name = contact.name;
                    this.primaryContact.phone = contact.phone;
                    this.primaryContact.phoneExt = contact.phoneExt;
                    this.primaryContact.locale = contact.locale;
                } else if (contact.contactType === '01') {
                    this.requestor.email = contact.email;
                    this.requestor.name = contact.name;
                    this.requestor.phone = contact.phone;
                    this.requestor.phoneExt = contact.phoneExt;
                    this.requestor.locale = contact.locale;
                }
            }, this);

            this.showRequestorContact = !((this.primaryContact.email === this.requestor.email)
                && (this.primaryContact.name === this.requestor.name)
                && (this.primaryContact.phone === this.requestor.phone)
                && (this.primaryContact.phoneExt === this.requestor.phoneExt))
                && Object.keys(this.requestor).length > 0;
        }
    }

    setPlacardStatus(placardStatus: string, cancelDate: string = ''): string {
        switch (placardStatus) {
            case PLACARD_STATUS.PENDING:
            case PLACARD_STATUS.ACTIVE:
            case PLACARD_STATUS.CREATED_2:
                return this._translate.transform('upplm.common.awaitingapproval');
            case PLACARD_STATUS.CANCELLED:
                return `${this._translate.transform('upplm.anonymousdashboard.canceledon')} ${cancelDate}`;
            case PLACARD_STATUS.CREATED_1:
            case PLACARD_STATUS.CREATED:
                return this._translate.transform('upplm.common.created');
            case PLACARD_STATUS.REJECTED:
            case PLACARD_STATUS.AGED:
            case PLACARD_STATUS.EXPIRED_2:
                return this._translate.transform('upplm.common.firstpickupdatedelayed');
            case PLACARD_STATUS.EXPIRED_1:
            case PLACARD_STATUS.EXPIRED:
                return this._translate.transform('upplm.common.expired');
            case PLACARD_STATUS.PAUSED:
                return this._translate.transform('upplm.common.pickupspaused');
            case PLACARD_STATUS.DISPATCHED:
                return this._translate.transform('upplm.common.ready');
            default:
                return '';
        }
    }

    setPlacardStatusDetail(placardStatus: string, phoneText: string = '', nndays: number = null, reactivationDate: string = ''): string {
        switch (placardStatus) {
            case PLACARD_STATUS.PENDING:
            case PLACARD_STATUS.ACTIVE:
            case PLACARD_STATUS.CREATED_2:
                return `${this._translate.transform('upplm.listview.wellletyouknow')} UPS Pickup Point ${this._translate.transform('upplm.listview.details')}`;
            case PLACARD_STATUS.CREATED_1:
            case PLACARD_STATUS.CREATED:
                return this._translate.transform('upplm.common.pleaseconfirm');
            case PLACARD_STATUS.REJECTED:
            case PLACARD_STATUS.AGED:
            case PLACARD_STATUS.EXPIRED_2:
                return `${this._translate.transform('upplm.listview.thedateofyourfirstrequested')}. ${this._translate.transform('upplm.common.pleasecall')} ${phoneText} ${this._translate.transform('upplm.listview.ifyouneedmore')}.`;
            case PLACARD_STATUS.EXPIRED_1:
            case PLACARD_STATUS.EXPIRED:
                return `${this._translate.transform('upplm.listview.youhave')} ${nndays} ${this._translate.transform('upplm.listview.daystoconfirm')}.`;
            case PLACARD_STATUS.PAUSED:
                return `${this._translate.transform('upplm.listview.yourpickupswillresumeon')} ${reactivationDate}`;
            default:
                return '';
        }
    }

    setLocationType(locationType: string): string {
        if (locationType === 'Single Location') {
            return this._translate.transform('upplm.common.no')
        } else {
            return this._translate.transform('upplm.common.yes');
        }
    }

    getPickupScheduledDays() {
        this.pickupScheduledDays = [];
        this.placardDetailData.placardInformation.pickupDetails.selectedDays.forEach(function (element) {
            let day: string = '';
            day = `${this._translate.transform(DAYS_SHORTCODE_TRANSLATION.find(x => x.dayshortcode === element.dayOfWeekCode).key)}
                    ${this.getTimeToShow(element.selectedPreferredTime)} - ${this.getTimeToShow(element.selectedLatestTime)}`;
            this.pickupScheduledDays.push(day);
        }, this);
    }

    getTimeToShow(formattedTime: string): string {
        if (this.globalRegioForShowTimes === CONTINENTAL_REGIONS.EMEA) {
            return this._rawTime.transform(formattedTime);
        } else {
            return formattedTime;
        }
    }

    setUrlPicture() {
        this.isPlacardVerification && (this.placardDetailData.placardInformation.placardVerification.placardImage && this.placardDetailData.placardInformation.placardVerification.placardImage !== null)
            ? this.urlImageLink = `data: ${this.placardDetailData.placardInformation.placardVerification.placardImage.extension};base64, ${this.placardDetailData.placardInformation.placardVerification.placardImage.contents}`
            : this.urlImageLink = '';
    };

    public openPicture() {
        let newTab = window.open();
        let found = this.urlImageLink.search('data');
        if (found > 0) {
            this.urlImageLink = `data:${this.placardDetailData.placardInformation.placardVerification.placardImage.extension};base64,${this.placardDetailData.placardInformation.placardVerification.placardImage.contents}`;
        }
        newTab.document.body.innerHTML = `<img src="${this.urlImageLink.trim()}" width="80%" height="80%">`;
    }

    goToPlacardVerification() {
        this.router.navigateByUrl(`${RouteURLConstants.UPPLM_VIEW_PLACARD_VERIFICATION_ROUTE}?loc=${this._commonService.locale}&placardid=${this.placardDetailData.placardId}`);
    }

    setMetalBox(metalBoxInd: boolean): string {
        if (this.isPlacardLocation) {
            if (metalBoxInd) {
                return this._translate.transform('upplm.cac.yes');
            } else {
                return this._translate.transform('upplm.cac.no');
            }
        }
    }

    setShowButtonStatus() {
        this.placardDetailData.placardStatus === PLACARD_STATUS.CREATED || this.placardDetailData.placardStatus === PLACARD_STATUS.EXPIRED_1 || this.placardDetailData.placardStatus === PLACARD_STATUS.EXPIRED ? this.showConfirmButton = true : this.showConfirmButton = false;
    }

    viewTemporaryPlacard(value: any) {
        window.open(value, "_blank");
    }

    getPlacardDetails(placardDetails: PlacardDetails) {
        if (this.validatePlacardDetails(placardDetails)) {
            if (COUNTRY_LANGUAGE.find(x => x.key === this.countryCode).region === CONTINENTAL_REGIONS.EMEA) {
                this.placardSize = A4_PLACARD_SIZE;
            } else {
                this.placardSize = this.getPlacardSize(placardDetails);
            }
            this.shipmentType = this.getShipmentType(placardDetails.placardType);
        }
    }

    getPlacardSize(placardDetails: PlacardDetails): string {
        let size: string = '';
        if (placardDetails.placardSize && placardDetails.placardSize.includes(' / A4')) {
            size = placardDetails.placardSize.replace(' / A4', '');
        } else {
            size = placardDetails.placardSize;
        }
        if (placardDetails.placardSize && placardDetails.placardSize.includes('Portrait')) {
            size = size.replace('Portrait', this._translate.transform('upplm.placarddetails.portrait'));
        } else if (placardDetails.placardSize && placardDetails.placardSize.includes('Landscape')) {
            size = size.replace('Landscape', this._translate.transform('upplm.placarddetails.landscape'))
        }
        return size;
    }

    validatePlacardDetails(placardDetails: PlacardDetails): boolean {
        if (!(placardDetails !== null ||
            (typeof placardDetails !== 'undefined' && placardDetails))) {
            return false;
        }
        return true;
    }

    getShipmentType(shipmentType: string): string {

        if (shipmentType == null || typeof shipmentType == 'undefined') {
            return "";
        }

        if (shipmentType.trim() === 'LAB SPECIMEN') {
            return this._translate.transform('upplm.placarddetails.labspecimen').toUpperCase();
        }
        if (shipmentType.trim() === 'NON-LAB') {
            return this._translate.transform('upplm.placarddetails.nonlab').toUpperCase();
        }

    }

    validatePlacardLocationDetails(placardLocationDetails: PlacardLocation) {
        if (!(placardLocationDetails !== null ||
            (typeof placardLocationDetails !== 'undefined' && placardLocationDetails))) {
            return false;
        }
        return true;
    }

    setNotifications(notificationsToChange: Contact[]): string[] {
        let changes: string[] = [];
        if (this.primaryContact.email.length > 0) {
            changes.push(`${this.primaryContact.email} - ${this.getPosEmailValue(this.primaryContact.locale)}`);
        }
        if (this.showRequestorContact) {
            changes.push(`${this.requestor.email} - ${this.getPosEmailValue(this.requestor.locale)}`);
        }
        if (notificationsToChange) {
            notificationsToChange.forEach(function (email) {
                changes.push(`${email.email} - ${this.getPosEmailValue(email.locale)}`);
            }, this);
        }
        return changes;
    }

    getPosEmailValue(emailLocale: string): string {
            const data = COUNTRY_LANGUAGE.find(x => x.locale === emailLocale);
            return `${data.key} ${this._translate.transform(data.language)}`;
    }

    prepareLinksForTemporaryPlacard(countryCode: string, temporaryPlacardURL: string): Link[] {
        let results: Link[] = [];
        LANGUAGES_COUNTRIES_LOCALES.forEach(function (item) {
            if (item.countryCode === countryCode && item.showTemporaryPlacard) {
                results.push(new Link(`${temporaryPlacardURL}?loc=${item.locale}`, `${this._translate.transform('upplm.common.viewtemporaryplacard')} (${this._translate.transform(item.language)})`));
            }
        }, this)
        return results;
    }

    getPlacardLocationDetails() {
        if (this.validatePlacardLocationDetails(this.placardDetailData.placardInformation.placardLocation)) {
            this.placardLocation = this.translatePlacardLocation(this.placardDetailData.placardInformation.placardLocation.placardLocation);
            this.pickupLocation = this.translatePickupLocation(this.placardDetailData.placardInformation.placardLocation.pickupLocation);
        }
    }

    translatePlacardLocation(value: string): string {
        if (PLACARD_LOCATION.some(x => x.key.toLowerCase() === value.trim().toLowerCase())) {
            return this._translate.transform(PLACARD_LOCATION.find(x => x.key.toLowerCase() === value.trim().toLowerCase()).value);
        } else {
            return '';
        }
        
    }

    translatePickupLocation(value: string): string {
        return this._translate.transform(PICKUP_LOCATION_KEY.find(x => x.key.toLowerCase() === value.trim().toLowerCase()).value);
    }

    redirectTo(section) {
        this._storedDataService.placardId = this.placardDetailData.placardId;
        this._storedDataService.placardStatus = this.placardStatusToShow;
        this._storedDataService.placardCrisStatus = this.placardDetailData.placardStatus;
        this.prepareSectionToEdit(section);
        this.sectionToEdit = section;
        this.showParent = false;
        this.showEditSection = true;
    }

    hideSection(hideEditSection) {
        this.showEditSection = false;
        this.showParent = true;
        if (this._storedDataService.areAutoApprovalChangesAllowed) {
            this._storedDataService.areAutoApprovalChangesAllowed = false;
            this.getPlacardDetail(this.placardId);
        }
        if (!this.thereArePendingChanges && !this._storedDataService.areAutoApprovalChangesAllowed && this._storedDataService.updateRequestedSaved) {
            this.thereArePendingChanges = true;
            this._storedDataService.updateRequestedSaved = false;
        }
    }

    prepareSectionToEdit(section) {
        this._storedDataService.countryCode = this.countryCode;
        this._storedDataService.globalRegion = this.globalRegionCountry;
        this._storedDataService.globalRegionForShowTimes = this.globalRegioForShowTimes;
        switch (section) {
            //For Location and Pickup Details, data must be filled for both sections
            case EDIT_SECTIONS.PLACARD_DETAILS:
                this._storedDataService.placardDetails = this._placardDetailsHelperService.preparePlacardDetailsForEdit(this.placardDetailData.placardInformation.placardDetails, this._storedDataService.globalRegion);
                break;
            case EDIT_SECTIONS.LOCATION_DETAILS:
            case EDIT_SECTIONS.PICKUP_DETAILS:
                this._storedDataService.locationDetails = this._locationDetailsHelperService.prepareLocationDetailsForEdit(
                    this.placardDetailData.placardInformation.locationDetails.address, this.placardDetailData.companyName,
                    this.placardDetailData.placardInformation.locationDetails.clientKeys[0].clientKey.toString());
                this._storedDataService.pickupDetails = this._pickupDetailsHelperService.getCurrentPickupDetailsValues(
                    this.placardDetailData.placardInformation.pickupDetails);
                break;
            case EDIT_SECTIONS.CONTACT_DETAILS:
                this._storedDataService.contactDetails = this._contactDetailsHelperService.prepareContactDetailsForEdit(this.placardDetailData.placardInformation.contactDetails);
                break; 
            case EDIT_SECTIONS.NOTIFICATION_DETAILS:
                this._storedDataService.contactDetails = this._contactDetailsHelperService.prepareContactDetailsForEdit(this.placardDetailData.placardInformation.contactDetails);
                this._storedDataService.notificationDetails = this._notificationDetailsHelperService.prepareNotificationDetailsForEdit(this.placardDetailData.placardInformation.notifications);
                break;
            case EDIT_SECTIONS.PLACARD_LOCATION:
                this._storedDataService.placardLocationDetails = this._placardLocationDetailsHelperService.preparePlacardLocationDetailsForEdit(this.placardDetailData.placardInformation.placardLocation);
                break;
            case EDIT_SECTIONS.PLACARD_VERIFICATION:
                this._storedDataService.placardVerificationData = this._placardVerificationHelperService.preparePlacardVerificationDataForEdit(this.placardDetailData.placardInformation.placardVerification);
                this._storedDataService.locationDetails = this._locationDetailsHelperService.prepareLocationDetailsForEdit(
                    this.placardDetailData.placardInformation.locationDetails.address, this.placardDetailData.companyName,
                    this.placardDetailData.placardInformation.locationDetails.clientKeys[0].clientKey.toString());
                break;
        }
    }
}